import requestFunctions from "../../functions/requestFunctions";


export const state = {
  PRODUCTS_CATEGORIES_ITEM: {},
  PRODUCTS_CATEGORIES_LIST: [],
  PRODUCTS_CATEGORIES_TABLE_DATA: [],
  PRODUCTS_CATEGORIES_ARRAY_DATA: [],
  PRODUCTS_CATEGORIES_TOTAL_ROWS: 0
}

export const getters = {
  GET_PRODUCTS_CATEGORIES_ITEM: (state) => {
    return state.PRODUCTS_CATEGORIES_ITEM;
  },
  GET_PRODUCTS_CATEGORIES_LIST: (state) => {
    return state.PRODUCTS_CATEGORIES_LIST;
  },
  GET_PRODUCTS_CATEGORIES_TABLE_DATA: (state) => {
    return state.PRODUCTS_CATEGORIES_TABLE_DATA;
  },
  GET_PRODUCTS_CATEGORIES_ARRAY_DATA: (state) => {
    return state.PRODUCTS_CATEGORIES_ARRAY_DATA;
  },
  GET_PRODUCTS_CATEGORIES_TOTAL_ROWS: (state) => {
    return state.PRODUCTS_CATEGORIES_TOTAL_ROWS;
  }
}

export const mutations = {

  UPDATE_PRODUCTS_CATEGORIES_ITEM(state, item) {
    state.PRODUCTS_CATEGORIES_ITEM = item;
  },

  UPDATE_PRODUCTS_CATEGORIES_LIST(state, list) {
    
    state.PRODUCTS_CATEGORIES_LIST = list.data;

    state.PRODUCTS_CATEGORIES_TOTAL_ROWS = list.total;
    list = list.data;
    
    state.PRODUCTS_CATEGORIES_TABLE_DATA = [];
    state.PRODUCTS_CATEGORIES_ARRAY_DATA = [];

    list.forEach(el => {

      state.PRODUCTS_CATEGORIES_TABLE_DATA.push({
        'uuid' : el.uuid,
        'id'   : el.id,
        'name' : el.name,
        'comments'   : el.comments,
        'created_at' : el.created_at,
        'updated_at' : el.updated_at,
      });

      state.PRODUCTS_CATEGORIES_ARRAY_DATA.push({
        id: el.id,
        uuid: el.uuid,
        name: el.name
      });
    });
  },
}

export const actions = {

  async FETCH_PRODUCTS_CATEGORIES_ITEM({ commit }, payload) {

    let query_url = 'https://api.tradeanalytic.ru/v1/products/categories/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_PRODUCTS_CATEGORIES_ITEM', response.data);
      return response.data;
    }
  },

  async FETCH_PRODUCTS_CATEGORIES_LIST({ commit }, payload= {}) {

    let query_url = 'https://api.tradeanalytic.ru/v1/products/categories';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_PRODUCTS_CATEGORIES_LIST', response.data);
      return response.data;
    }
  },

  async FETCH_PRODUCTS_CATEGORIES_CREATE({ commit }, payload) {

    let query_url = 'https://api.tradeanalytic.ru/v1/products/categories';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'POST');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }
  },

  async FETCH_PRODUCTS_CATEGORIES_UPDATE({ commit }, payload) {

    let query_url = 'https://api.tradeanalytic.ru/v1/products/categories/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'PUT');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }
  },

  async FETCH_PRODUCTS_CATEGORIES_DELETE({ commit }, payload) {

    let query_url = 'https://api.tradeanalytic.ru/v1/products/categories/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'DELETE');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }
  },
}